import React from "react";


import {
    Col, Row
} from "react-bootstrap";

import {
    NavLink
} from "react-router-dom";


import {
    SvgIconComponent
} from "@Components/Elements";


import IconProfileSm from "./@Icons/icon-profile-sm.svg";
import IconSettingsSm from "./@Icons/icon-settings-sm.svg";
import IconUploadSm from "./@Icons/icon-upload-sm.svg";
import IconSecuritySm from "./@Icons/icon-security-sm.svg";
import IconArrowsSm from "./@Icons/icon-arrows-sm.svg";


import "./index.scss";


export const UserDashboardPageUserMenu:React.FC = () => {

    return (
        <Col xs={12} lg={3} className={'user-dashboard-navigation'}>
            <Row className={'user-dashboard-navigation__content'}>

                <Col xs={12} className={'user-dashboard-navigation-menu'}>
                    <Row className={'user-dashboard-navigation-menu__content'}>

                        <Col xs={6} lg={12} className={'user-dashboard-navigation-menu-element'}>
                            <NavLink to={'/dashboard/profile'} className={'user-dashboard-navigation-menu-link'}>
                                <SvgIconComponent iconSource={IconProfileSm} className={'navigation-link-icon'} />
                                <span className={'navigation-link-text'}>Profile</span>
                            </NavLink>
                        </Col>

                        <Col xs={6} lg={12} className={'user-dashboard-navigation-menu-element'}>
                            <NavLink to={'/dashboard/settings'} className={'user-dashboard-navigation-menu-link'}>
                                <SvgIconComponent iconSource={IconSettingsSm} className={'navigation-link-icon'} />
                                <span className={'navigation-link-text'}>Settings</span>
                            </NavLink>
                        </Col>

                        <Col xs={6} lg={12} className={'user-dashboard-navigation-menu-element'}>
                            <NavLink to={'/dashboard/upload-documents'} className={'user-dashboard-navigation-menu-link'}>
                                <SvgIconComponent iconSource={IconUploadSm} className={'navigation-link-icon'} />
                                <span className={'navigation-link-text'}>Uploaded documents</span>
                            </NavLink>
                        </Col>

                        <Col xs={6} lg={12} className={'user-dashboard-navigation-menu-element'}>
                            <NavLink to={'/dashboard/privacy-and-security'} className={'user-dashboard-navigation-menu-link'}>
                                <SvgIconComponent iconSource={IconSecuritySm} className={'navigation-link-icon'} />
                                <span className={'navigation-link-text'}>Privacy & Security</span>
                            </NavLink>
                        </Col>

                        <Col xs={6} lg={12} className={'user-dashboard-navigation-menu-element'}>
                            <NavLink to={'/dashboard/connected-apps'} className={'user-dashboard-navigation-menu-link'}>
                                <SvgIconComponent iconSource={IconArrowsSm} className={'navigation-link-icon'} />
                                <span className={'navigation-link-text'}>Connected Apps</span>
                            </NavLink>
                        </Col>

                    </Row>
                </Col>

            </Row>
        </Col>
    );

};


export default UserDashboardPageUserMenu;
